import { atomWithStorage } from 'jotai/utils';
import { LOCAL_STORAGE } from '@/functions/constants/enums';

export const TemporalSearchUserImpressionKey = LOCAL_STORAGE.TEMPORAL_SEARCH_USER_IMPRESSION.KEY;
export const AllSearchUserImpressionKey = LOCAL_STORAGE.ALL_SEARCH_USER_IMPRESSION.KEY;

export const tempImpressionAtom = atomWithStorage<number[]>(TemporalSearchUserImpressionKey, []);
export const allImpressionAtom = atomWithStorage<number[]>(AllSearchUserImpressionKey, []);
